var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "list",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1H1V7H7V1Z",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H1V19H7V13Z",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 25H1V31H7V25Z",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H32",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H20",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H32",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H20",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26H32",
    className: "stroke",
    stroke: "#5E5E5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30H20",
    className: "stroke",
    stroke: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.19d9e43ad3181e105ee15e26fec40912.svg";
export { ForwardRef as ReactComponent };